import { render, staticRenderFns } from "./SelectPill.vue?vue&type=template&id=2799b84e&scoped=true"
import script from "./SelectPill.vue?vue&type=script&lang=js"
export * from "./SelectPill.vue?vue&type=script&lang=js"
import style0 from "./SelectPill.vue?vue&type=style&index=0&id=2799b84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799b84e",
  null
  
)

export default component.exports